var exports = {
  "M": "x61f99309--8ae3f9--tab",
  "u": "x61f99309--8ae3f9--tab_selected",
};

module.exports = exports;
